

import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import { NotificationProvider } from '../../context/NotificationContext';

const DashboardLayout = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <NotificationProvider>
      {/* ✅ REMOVED overflow-hidden */}
      <div className="flex min-h-screen">
        {/* Mobile overlay */}
        {isMobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-40 z-20 md:hidden"
            onClick={closeMobileMenu}
          />
        )}

        {/* Sidebar */}
        <Sidebar
          isOpen={isMobileMenuOpen}
          closeMenu={closeMobileMenu}
        />

        {/* Main content */}
        <div className="flex-1 flex flex-col">
          <Header onMobileMenuToggle={toggleMobileMenu} />

          {/* ✅ SCROLLABLE CONTENT */}
          <main className="flex-1 mt-16 md:ml-64 p-4 overflow-y-auto bg-gray-100">
            <Outlet />
          </main>
        </div>
      </div>
    </NotificationProvider>
  );
};

export default DashboardLayout;
